import React from "react";
import { Link } from 'react-router-dom';
import { Row, Col, Button } from "antd";

function Exception500(){
    return(
        <div>
            <Row
                style={{marginTop: "10%"}}
            >
                <Col xs={24} sm={24} md={24} lg={13} xl={13}>
                    <img 
                        style={{display: "block", margin: "auto", width: "500px", height: "350px"}} 
                        src="https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg" 
                        alt=""
                    />
                </Col>
                <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                    <div>
                        <h1 className={"h1Exception"}>500</h1>
                        <div className={"desc"}>{"Desculpe, o servidor está passando por dificuldades."}</div>
                        <Button type="primary" style={{marginTop: -10}}>
                            <Link to={"/"}>{"Voltar para o Inicio"}</Link>
                        </Button>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default Exception500;


// WEBPACK FOOTER //
// ./src/components/common/exception/500.jsx